// Footer.tsx
import {
  Box,
  Flex,
  Text,
  HStack,
  Image,
  Link,
  IconButton,
  VStack,
  Icon
} from '@chakra-ui/react'
import {
  FaFacebookF,
  FaDiscord,
  FaYoutube,
  FaRegNewspaper,
  FaTelegram
} from 'react-icons/fa'
import { EmailIcon } from '@chakra-ui/icons'

const Footer = () => {
  return (
    <Box bg="dark.bg" py={10} px={4} borderTop="1px" borderColor="dark.border">
      <Flex
        maxW="6xl"
        mx="auto"
        direction={{ base: 'column', md: 'row' }}
        align="center"
        justify="space-between"
      >
        {/* 좌측 로고 및 소셜 아이콘 */}
        <VStack align="start" spacing={4}>
          <HStack spacing={3}>
            {/* <Image src="/images/logo/logo.png" alt="Logo" h="28px" /> */}
            <IconButton
              as="a"
              href="https://www.youtube.com/@winningbot"
              target="_blank"
              rel="noopener noreferrer"
              icon={<FaYoutube />}
              aria-label="youtube"
              variant="ghost"
              color="gray.400"
              _hover={{ color: 'brand.500', bg: 'dark.hover' }}
              isRound
            />
            {/* <IconButton
              as="a"
              href="https://t.me/jwbdidhs"
              target="_blank"
              rel="noopener noreferrer"
              icon={<FaTelegram />}
              aria-label="telegram"
              variant="ghost"
              color="gray.400"
              _hover={{ color: 'brand.500', bg: 'dark.hover' }}
              isRound
            /> */}
          </HStack>
        </VStack>

        {/* 우측 정보 */}
        <Box mt={{ base: 8, md: 0 }} color="gray.500" fontSize="sm">
          <Text>Copyright © 2025 WinningBot. All rights reserved.</Text>
        </Box>
      </Flex>
    </Box>
  )
}

export default Footer
